import React from "react";
import { SxStyleProp } from "theme-ui";
import { CloseIcon } from "../icons";
import { Button } from "../Button";
import { Box } from "../Box";

export const sizes = {
  sm: { fontSize: 0, px: 2 },
  md: { fontSize: 1, px: 2 },
  lg: { fontSize: 2, px: 3 },
};

export const TagClose: React.FunctionComponent<{
  size: string;
  sx?: SxStyleProp;
  onClick: (e: React.MouseEvent) => void;
}> = ({ size = "16px", sx, ...restProps }) => (
  <Button p={0} ml={1} mr={-1} sx={{ ...(sx as any) }} {...restProps}>
    <CloseIcon size={size} />
  </Button>
);

interface Props {
  sx?: SxStyleProp;
  size?: keyof typeof sizes;
  radius?: "default" | "full";
}

const Tag: React.FunctionComponent<Props> = React.forwardRef(
  ({ sx, size = "sm" as "sm", radius = "default", ...restProps }, ref) => (
    <Box
      ref={ref}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        fontSize: sizes[size].fontSize,
        px: sizes[size].px,
        py: 1,
        bg: "primary",
        color: "white",
        borderRadius: radius,

        ...(sx as any),
      }}
      {...restProps}
    />
  ),
);

Tag.displayName = "Tag";

export default Tag;
